import { somenteNumeros } from "@refere/ui-utils/ui/utils/format";

import { fetchWrapper } from "../../../utils/fetch";
import { globalState } from "../../global-state";
import { enumPasso } from "../../simulacao";
import { gotoPageCertificado } from "../certificado/certificado";
import { router } from "../../../App";

export interface IPassoContratacaoState {
    quatroUltimosDigitosCartao: string
    codTpCartao: number
    codEstadoCivil: number
    estadoCivilHelperText: string
    codSexo: string
    dtNascimento: string
    email: string
    celular: string

    logradouro?: string
    nr?: string
    complemento?: string
    bairro?: string
    cidade?: string
    siglaUf?: string
    semNr?: boolean
    cep?: string

    tiposCartoes: { 
        codTpCartao: number
        nome: string
    }[]
    estadosCivis: {
        codEstadoCivil: number
        nome: string
    }[]
    sexos: {
        codSexo: string
        nome: string
    }[]
    ufs: {
        siglaUf: string
        nome: string
    }[]
}

export interface IEnderecoPorCepResponse{
    logradouro?: string
    bairro?: string
    cidade?: string
    uf?: string
}

const getPassoContratacao = () =>
    fetchWrapper<IPassoContratacaoState>("/api/contratacao")

export const getEnderecoPorCep = async (cep: string) => {
    globalState.isLoading.set(true);
    
    const response = await fetchWrapper<IEnderecoPorCepResponse>(`/api/enderecos/cep/${somenteNumeros(cep)}`);

    globalState.isLoading.set(false);
    return response
}

const postPassoContratacao = (toSave: IPassoContratacaoState) =>
    fetchWrapper("/api/contratacao", {
        method: "POST",
        body: JSON.stringify({
            ...toSave,
            cep: somenteNumeros(toSave.cep),
            celular: somenteNumeros(toSave.celular),
            tiposCartoes: [],
            estadosCivis: [],
            sexos: []
        } as IPassoContratacaoState),
        headers: {
            'Content-type': 'application/json; charset=UTF-8'
        }
    })

export const savePassoContratacao = async (toSave: IPassoContratacaoState) => {
    globalState.isLoading.set(true);

    const response = await postPassoContratacao(toSave);

    if (response) {
        globalState.simulacao.passoAlcancado.set(enumPasso.certificado);
        await gotoPageCertificado();
    }

    globalState.isLoading.set(false);
}

let passoContracao = null;

export const gotoPassoContratacao = async () => {
    if (!passoContracao) {
        globalState.isLoading.set(true);
        
        passoContracao = await getPassoContratacao();

        if (passoContracao) {
            globalState.passoContracao.set(passoContracao);
            await router.navigate("/seguro", { replace: true });
        }
    }

    if (passoContracao) 
        globalState.simulacao.passo.set(enumPasso.contratacao);

    globalState.isLoading.set(false);
}